import React from 'react'
// import { initStore } from '../store'
// import { bindActionCreators } from 'redux';
// import withRedux from 'next-redux-wrapper';
import { connect } from 'react-redux';
// import { compose } from 'recompose';
import PropTypes from 'prop-types';

import AppCustomLink from '../../components/Common/AppCustomLink';
// import Link from 'next/link';
import { cdnApi, podcastTypes, firestoreApi, appleStoreUrl, playStoreUrl } from '../../lib/utils';
import { fetchTopChartsPodcasts, fetchTopChartsEpisodes } from '../../actions';
// import { fetchUserSubscriptions } from '../actions/PodcastActions';

import { NextSeo } from 'next-seo';
import FollowedTags from '../../components/Common/FollowedTags';
import YourTags from '../../components/Common/YourTags';
import NewTag from '../../components/Common/NewTag';
import AppAlertDiv from '../../components/Common/AppAlertDiv';
// import FireStoreParser from 'firestore-parser';
// import Router from 'next/router';

export default class Tags extends React.Component {
    // static async getInitialProps(context) {
    //     // // const podcastTypeId = params && params.id;
    //     // const genreId = 'All'; //.replace('-and-', ' & ');
    //     // // try {
    //     // const results = await Promise.all([fetchTopChartsPodcasts(genreId, 1), fetchTopChartsEpisodes(genreId, 1)]);
    //     // let finalJsonArray = results[0];
    //     // let finalJsonArrayEpisodes = results[1];
    //     // return { podcastsArray: finalJsonArray, episodesArray: finalJsonArrayEpisodes, podcastTypeId: genreId };
    // }

    constructor(props) {
        super(props);
        // this.state = {
        //   hasMorePodcasts: true, hasMoreEpisodes: true, podcastsArray: props.podcastsArray,
        //   episodesArray: props.episodesArray, boxShadow: '', forceRenderEpisodes: true
        // };
    }

    render() {
        // const { podcastTypeId } = this.props;
        // const { podcastsArray, episodesArray } = this.props;

        return (
            <div>
                <NextSeo
                    title='Accelerated Web Player Collections'
                    description='Tags'
                    canonical='https://tedapp.ai/collections'
                    noindex={true}
                    nofollow={true}
                />
                <h2 style={{ display: 'flex', alignItems: 'center', marginBottom: '1em' }}>
                    Your Collections &nbsp; &nbsp;<NewTag /></h2>

                <hr className='separator' />
                <br />
                <YourTags />
            </div>
        );
    }
}

Tags.propTypes = {
    podcastsArray: PropTypes.array,
    episodesArray: PropTypes.array,
    podcastTypeId: PropTypes.string
}


// export default connect(null, null)(Tags);
